module.exports = __webpack_public_path__ + "assets/img/xbox-yuyue-f82fadff.png";